<isav-page-content>
    <p class="access-denied-message mt-5 mb-5">You do not have permissions to see this content.</p>
</isav-page-content>
